const formatStyledListData = (list: any) =>
  list?.map((listItem: any) => {
    const updatedList = { ...listItem }
    if (updatedList.value?.content?.length > 0) {
      const updatedContent = {
        content: updatedList.value.content.map((item: any) =>
          addMissingValues(item)
        )
      }
      updatedList.value.content = { raw: JSON.stringify(updatedContent) }
    }
    if (
      updatedList.valueTwo?.content?.length &&
      updatedList.valueTwo.content[0]?.content?.length > 0 &&
      updatedList.valueTwo.content[0].content[0].value
    ) {
      updatedList.tooltip =
        '<p>' + updatedList.valueTwo.content[0].content[0].value + '</p>'
    }
    return updatedList
  })

const addMissingValues = (node: any) => {
  const updatedNode = {
    ...node,
    data: node.data || [],
    marks: node.marks || []
  }
  if (node.content?.length) {
    updatedNode.content = node.content.map((n: any) => addMissingValues(n))
  }
  return updatedNode
}

const headingListIcon = (icon: string) => {
  switch (icon) {
    case 'bullet-gray':
      return 'before:bg-icon-gray-bullet'
    case 'checkmark-gray':
      return 'before:bg-icon-gray-check'
    case 'checkmark-circle-solid-gray':
      return 'before:bg-icon-gray-checkmark-circle'
    case 'checkmark-orange':
      return 'before:bg-icon-orange-check'
    case 'checkmark-circle-solid-orange':
      return 'before:bg-icon-orange-circle-solid-checkmark'
    case 'plus-circle-gray':
      return 'before:bg-icon-gray-plus-circle'
    case 'checkmark-green':
      return 'before:bg-icon-checkmark-green'
    default:
      return ''
  }
}

export { addMissingValues, formatStyledListData, headingListIcon }
